import React from 'react';
import { Chip } from '@mui/material';
import { STATUS_PRESETS, getPublishStatusPreset } from './statusPresets';

/**
 * Consistent status chip (Phase 7.2).
 * Pass preset key, raw meta, or post for publish pipeline status.
 */
export default function StatusChip({
  status,
  label,
  color,
  variant,
  post,
  labelPrefix = '',
  size = 'small',
  sx,
  ...chipProps
}) {
  let meta = { label: label || status || 'Unknown', color: color || 'default', variant: variant || 'outlined' };

  if (post) {
    meta = getPublishStatusPreset(post);
  } else if (status && STATUS_PRESETS[status]) {
    meta = STATUS_PRESETS[status];
  } else if (label && color) {
    meta = { label, color, variant: variant || 'outlined' };
  }

  return (
    <Chip
      label={`${labelPrefix}${meta.label}`}
      color={meta.color}
      variant={meta.variant}
      size={size}
      sx={sx}
      {...chipProps}
    />
  );
}

/** @deprecated Use StatusChip with post prop — kept for Posts imports. */
export function PublishStatusChip({ post, labelPrefix = '', ...rest }) {
  return <StatusChip post={post} labelPrefix={labelPrefix} {...rest} />;
}
